// @flow
import * as React from 'react';

export const ButtonGroup = ({ children }: { children: React.Node }) => (
  <div
    className="br1 ButtonGroup"
    style={{ boxShadow: '0 1px 0 0 rgba(0, 0, 0, 0.125)', marginBottom: 1 }}
  >
    {React.Children.map(children, (child, index) => {
      if (!child) return null;

      const className = Boolean(child.props.className)
        ? child.props.className
        : 'button-reset bg-animate pointer br1 ba blue hover-dark-blue ph3 pv2 lh-solid hover-shadow bg-white';

      if (index === 0) {
        return React.cloneElement(child, {
          style: {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            borderRight: 0,
          },
          className,
        });
      }

      if (index === React.Children.count(children) - 1) {
        return React.cloneElement(child, {
          style: { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 },
          className,
        });
      }

      return React.cloneElement(child, {
        style: { borderRadius: 0, borderRight: 0, borderLeft: 0 },
        className,
      });
    })}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Common/ButtonGroup.js